<template>
    <div class='overlay' v-if='show'>
        <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
    </div>
</template>
<style>
    .overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: black;
        opacity: 0.5;
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 40pt;
    }

    .fa.fa-refresh {
        width: initial;
    }
</style>
<script>

import OverlayService from '../services/overlay-service'

export default {

  data () {
    return {
      show: false
    }
  },

  mounted () {
    OverlayService.on('show', value => {
      this.show = value
    })
  },

  destroyed () {
    OverlayService.off('show')
  }

}
</script>

